import {Component} from '@angular/core';
import {faAt} from "@fortawesome/free-solid-svg-icons/faAt";
import {faMapLocationDot} from "@fortawesome/free-solid-svg-icons/faMapLocationDot";
import {faPhone} from "@fortawesome/free-solid-svg-icons/faPhone";
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {RouterLink} from '@angular/router';
import {LeafletMapWrapperComponent} from "./leaflet-map-wrapper/leaflet-map-wrapper.component";
import {Constants} from "../../constants";

@Component({
  selector: 'app-contact-section',
  templateUrl: './contact-section.component.html',
  styleUrls: ['./contact-section.component.scss'],
  imports: [FaIconComponent, RouterLink, LeafletMapWrapperComponent]
})
export class ContactSectionComponent {

  protected readonly faPhone = faPhone;
  protected readonly faAt = faAt;
  protected readonly faMapLocationDot = faMapLocationDot;
  protected readonly routes = Constants.Routes;

  protected readonly contact = Constants.Contact;
  protected readonly address = Constants.Address;

}
